const baseUrl = process.env.REACT_APP_SERVER_URI ?? 'http://localhost:4000';
const normalizedBaseUrl = baseUrl.replace(/\/$/, '');

const buildUrl = (path) => `${normalizedBaseUrl}${path.startsWith('/') ? path : `/${path}`}`;

export const submitConsultationRequest = async (email, signal) => {
  const response = await fetch(buildUrl('/api/contact/consultation'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
    signal,
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok || !payload.success) {
    throw new Error(payload.message ?? `Request failed with status ${response.status}`);
  }

  return payload;
};

const contactService = {
  submitConsultationRequest,
};

export default contactService;
